<template>
    <div>
        <div class="row justify-content-center">
            <div class="col-10">
                <div class="text-left section-title" style="padding: 5px;">
                    <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>User Account</span>
                </div>
            </div>

        </div>
        <div class="row" style="padding-left: 15px; padding-right: 15px;">
            <div class="col-6 offset-3">
                <div class="container form-background">
                    <div class="row">
                        <div class=" col-12 text-left form-title">
                            <span class="row-table-font-margins">{{ formTitle }}</span>
                        </div>
                      
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <label>First Name:</label>
                            <input type="text" v-model="firstName" placeholder="First name" class="form-control" />
                            <div v-if="submitted && !firstName" class="invalid-feedback d-block">First name is required</div>
                        </div>
                        <div class="col-md-6">
                            <label>Last Name:</label>
                            <input type="text" v-model="lastName" placeholder="Last name" class="form-control" />
                            <div v-if="submitted && !lastName" class="invalid-feedback">Last name is required</div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <label>Username:</label>
                            <input type="text" v-model="username" placeholder="Username" class="form-control" />
                            <div v-if="submitted && !username" class="invalid-feedback">Username is required</div>
                        </div>
                        <div class="col-md-6">
                            <label>Email:</label>
                            <input type="text" v-model="email" placeholder="Email" class="form-control" />
                            <div v-if="submitted && !email" class="invalid-feedback">Email is required</div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-md-6">
                            <label htmlFor="password">Password</label>
                            <input type="password" v-model="password" name="password" class="form-control" :class="{ 'is-invalid': confirmPassword && v$.confirmPassword.sameAsPassword.$invalid }" />
                            <!--<div v-if="submitted && !password && !id" class="invalid-feedback">Password is required</div>-->
                        </div>
                        <div class="col-md-6">
                            <label htmlFor="password">Confirm Password</label>
                            <input type="password" placeholder="Password" v-model.trim="v$.confirmPassword.$model" name="confirmPassword" class="form-control" :class="{ 'is-invalid': submitted && v$.confirmPassword.$error }" />
                            <div v-if="confirmPassword && v$.confirmPassword.sameAsPassword.$invalid" class="invalid-feedback">Passwords do not match</div>
                            <!-- <div style="margin-top:15px; border: 1px black solid"> -->
                            <!-- </div> -->
                        </div>
                    </div>

                   

                

               
                </div>
               
                <div class="text-right">
                    <button type="submit" @click="submit()" class="btn btn-submit" style="margin: 15px;">
                        Submit
                    </button>
                    <button @click="$router.go(-1)" class="btn btn-cancel">Cancel</button>
                </div>
            </div>

        </div>
       
        
    </div>
</template>
<script>
import { useVuelidate } from '@vuelidate/core';
    import { sameAsField } from '@/_helpers/validators';
    import { authenticationService } from "@/_services";
    import { Role } from '@/_helpers';
export default {
  data: function () {
    return {
      currentUser: null,
      firstName: "",
      lastName: "",
      username: "",
        password: "",
      confirmPassword:"",
      email: "",
      role: "Management",
      formTitle: "Add User",
      id: 0,
      numberOfBuildings: 0,
      submitted: false,
    };
  },
  created() {
    authenticationService.currentUser.subscribe((x) => (this.currentUser = x));
        },
        setup: () => ({ v$: useVuelidate() }),
        validations: {
           confirmPassword: { sameAsPassword: sameAsField('password') }
        },
  mounted() {
    //if (this.$route.params.id) {
    this.formTitle = "Edit Account";
    //  this.id = this.$route.params.id;
    //  console.log(this.currentUser);
    this.getUser();
    // }
  },
  methods: {
    getUser: function () {
      this.$http.get("/users/" + this.currentUser.id).then((response) => {
        (this.firstName = response.data.firstName),
          (this.lastName = response.data.lastName),
          (this.username = response.data.username),
          (this.email = response.data.email),
          (this.role = response.data.role),
          (this.numberOfBuildings = response.data.numberOfBuildings),
          (this.isActive = response.data.isActive);
        // this.post_code = response.data.postCode
      });
    },
    submit: function () {
      var canSubmit =
        this.firstName && this.lastName && this.username && this.email;
      if (!this.currentUser.id) canSubmit = canSubmit && this.password;

        this.submitted = true;
        this.v$.$touch();
        if (this.v$.$invalid) {
            return;
        }
      if (canSubmit)
        this.$http
          .put("/users/", {
            id: this.currentUser.id,
            firstName: this.firstName,
            lastName: this.lastName,
            username: this.username,
            email: this.email,
              password: this.password,
            role:this.role
          })
          .then(
              () => {
                  if (this.currentUser && this.currentUser.role === Role.Owner)
                      this.$router.push({ name: 'propertiesowner' })
                  else
                        this.$router.push("/management/users");
            },
            () => {
              alert("error");
              //  this.infoError = true
              //  this.loader = false
              this.password = "";
            }
          );
    },
  },
};
</script>